import {
    winW
} from "../components/_globeVar.js";
import { gsap } from "gsap";

$(function() {


    //nav開合
    let _h = true;
    const nav = $('.nav');
    const hamburger = $('.hamburger_link');
    const hamburger_link = $('.hamburger_link');

    if ($('.hodingpage').length > 0) {
        //hashTo --------------------------------------------
        let _hash;
        let hash_to;

        function hashTo(hash) {
            hash_to = $(hash).offset().top;
            gsap.to('html, body', {
                duration: .3,
                scrollTop: hash_to,
                ease: 'quart.out'
            });
        }

        $('.hodingpage_nav_link[href*="#"]').click(function(e) {
            e.preventDefault();
            _hash = $(this).attr('href');
            _hash = _hash.substr(_hash.indexOf('#'));
            hashTo(_hash);
            if (winW > 950) return;
            hamburger.removeClass('active');
            gsap.to(nav, {
                duration: .3,
                opacity: 0,
                display: 'none',
                ease: 'quart.out'
            });
            _h = !_h;
        });
    }

    if (winW > 950) return;

    gsap.set(nav, {
        opacity: 0,
        display: 'none'
    })
    hamburger_link.click(function() {
        if (_h) {
            hamburger.addClass('active');
            gsap.to(nav, {
                duration: .3,
                opacity: 1,
                display: 'block',
                ease: 'power2.out'
            });
        } else {
            hamburger.removeClass('active');
            gsap.to(nav, {
                duration: .3,
                opacity: 0,
                display: 'none',
                ease: 'quart.out'
            });
        }
        _h = !_h;
    });

});